/**
 * Resultados del recomendador — muestra tarjetas card-product según scoring.
 */
(function () {
  'use strict';

  function productIdKey(id) {
    return String(id);
  }

  function buildPoolIndex(poolRoot, hideItems) {
    var idToEl = {};
    var handleToEl = {};
    if (!poolRoot) return { idToEl: idToEl, handleToEl: handleToEl };
    poolRoot.querySelectorAll('[data-oleum-rec-product-item]').forEach(function (el) {
      var id = productIdKey(el.getAttribute('data-product-id'));
      var handle = (el.getAttribute('data-product-handle') || '').trim();
      if (id) idToEl[id] = el;
      if (handle) handleToEl[handle] = el;
      if (hideItems) el.hidden = true;
    });
    return { idToEl: idToEl, handleToEl: handleToEl };
  }

  function findPoolElement(row, index) {
    var p = row && row.product;
    if (!p) return null;
    var byId = index.idToEl[productIdKey(p.id)];
    if (byId) return byId;
    if (p.handle) return index.handleToEl[p.handle] || null;
    return null;
  }

  function mountRankedProducts(container, ranked, index) {
    if (!container || !index) return 0;

    var shown = 0;
    ranked.forEach(function (row) {
      var el = findPoolElement(row, index);
      if (!el) return;
      el.hidden = false;
      attachProductReason(el, row);
      container.appendChild(el);
      shown += 1;
    });
    return shown;
  }

  function attachProductReason(itemEl, row) {
    if (!itemEl || !row) return;

    itemEl.querySelectorAll('.oleum-rec-info, .oleum-rec-results__reason').forEach(function (el) {
      el.remove();
    });

    var text =
      row.explanation ||
      (row.reasons && row.reasons.length ? row.reasons.slice(0, 2).join(' ') : '');
    if (!text) return;

    var card = itemEl.querySelector('.oleum-product-card');
    if (!card) return;

    var media = card.querySelector('.card__media--carousel, .card__media');
    if (!media) return;

    var wrap = document.createElement('div');
    wrap.className = 'oleum-rec-info';

    var btn = document.createElement('button');
    btn.type = 'button';
    btn.className = 'oleum-rec-info__trigger';
    btn.setAttribute('aria-expanded', 'false');
    btn.setAttribute('aria-label', 'Por qué te lo recomendamos');
    btn.innerHTML =
      '<span class="oleum-rec-info__icon" aria-hidden="true">' +
      '<svg viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">' +
      '<circle cx="10" cy="10" r="6.5" stroke="currentColor" stroke-width="1.5"/>' +
      '<path d="M10 9.5V13" stroke="currentColor" stroke-width="1.5" stroke-linecap="round"/>' +
      '<circle cx="10" cy="7.25" r="0.75" fill="currentColor"/>' +
      '</svg></span>';

    var popover = document.createElement('div');
    popover.className = 'oleum-rec-info__popover';
    popover.setAttribute('role', 'tooltip');
    popover.id = 'oleum-rec-info-' + String(row.product && row.product.id ? row.product.id : Math.random()).replace(/\W/g, '');
    btn.setAttribute('aria-controls', popover.id);
    popover.innerHTML = '<p class="oleum-rec-info__text">' + escapeHtml(text) + '</p>';

    wrap.appendChild(btn);
    wrap.appendChild(popover);
    media.appendChild(wrap);
  }

  function closeAllRecInfo(root) {
    if (!root) return;
    root.querySelectorAll('.oleum-rec-info.is-open').forEach(function (info) {
      info.classList.remove('is-open');
      var trigger = info.querySelector('.oleum-rec-info__trigger');
      if (trigger) trigger.setAttribute('aria-expanded', 'false');
    });
  }

  function initRecInfoInteractions(root) {
    if (!root || root.dataset.oleumRecInfoInit) return;
    root.dataset.oleumRecInfoInit = '1';

    root.addEventListener('click', function (e) {
      var trigger = e.target.closest('.oleum-rec-info__trigger');
      if (trigger) {
        e.preventDefault();
        e.stopPropagation();
        var info = trigger.closest('.oleum-rec-info');
        if (!info) return;
        var willOpen = !info.classList.contains('is-open');
        closeAllRecInfo(root);
        if (willOpen) {
          info.classList.add('is-open');
          trigger.setAttribute('aria-expanded', 'true');
        }
        return;
      }
      if (!e.target.closest('.oleum-rec-info')) {
        closeAllRecInfo(root);
      }
    });

    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') closeAllRecInfo(root);
    });
  }

  function getPoolCatalog(catalog, index) {
    if (!index || !Object.keys(index.idToEl).length) return catalog || [];
    return (catalog || []).filter(function (p) {
      if (!p) return false;
      if (index.idToEl[productIdKey(p.id)]) return true;
      return !!(p.handle && index.handleToEl[p.handle]);
    });
  }

  function getResultProducts(result) {
    if (!result) return [];
    if (result.products && result.products.length) return result.products;
    return (result.primary_products || []).concat(result.complementary_products || []);
  }

  function hasShowableProducts(result, index) {
    if (!result || !index) return false;
    return getResultProducts(result).some(function (row) {
      return !!findPoolElement(row, index);
    });
  }

  function renderEducation(blocks, container) {
    if (!container) return;
    container.innerHTML = '';
    if (!blocks || !blocks.length) {
      container.hidden = true;
      return;
    }
    blocks.forEach(function (b) {
      var el = document.createElement('div');
      el.className = 'oleum-rec-education';
      el.innerHTML =
        '<h3>' +
        escapeHtml(b.title) +
        '</h3><p>' +
        escapeHtml(b.body) +
        '</p>';
      container.appendChild(el);
    });
    container.hidden = false;
  }

  function escapeHtml(s) {
    var d = document.createElement('div');
    d.textContent = s == null ? '' : String(s);
    return d.innerHTML;
  }

  function init() {
    var root = document.getElementById('oleum-recommendation-results');
    if (!root) return;

    var Engine = window.OleumProfileEngine;
    var Recommender = window.OleumRecommender;
    if (!Engine || !Recommender) return;

    var ctx = Engine.loadUserContext();
    var recCtx = Engine.recommendationContext ? Engine.recommendationContext(ctx) : ctx;
    var catalog = window.OleumProductCatalog || [];
    var poolIndex = buildPoolIndex(root, true);
    var poolCatalog = getPoolCatalog(catalog, poolIndex);
    var result = null;
    var urlHasContext = Engine.hasUrlContextParams && Engine.hasUrlContextParams();

    function buildRecOptions() {
      var total = parseInt(root.dataset.recTotalCount, 10);
      if (!isNaN(total) && total > 0) {
        return { totalCount: total };
      }
      var primary = parseInt(root.dataset.recPrimaryCount, 10);
      var complementary = parseInt(root.dataset.recComplementaryCount, 10);
      if (!isNaN(primary) || !isNaN(complementary)) {
        return {
          primaryCount: isNaN(primary) ? 6 : primary,
          complementaryCount: isNaN(complementary) ? 6 : complementary
        };
      }
      return { totalCount: 12 };
    }

    if (recCtx && poolCatalog.length) {
      result = Recommender.getRecommendations(poolCatalog, recCtx, buildRecOptions());
      try {
        sessionStorage.setItem('oleum_recommendation_result', JSON.stringify(result));
      } catch (e2) {}
    } else if (!urlHasContext) {
      try {
        var raw = sessionStorage.getItem('oleum_recommendation_result');
        if (raw) result = JSON.parse(raw);
      } catch (e) {}
    }

    if (recCtx && poolCatalog.length && result && !hasShowableProducts(result, poolIndex)) {
      result = Recommender.getRecommendations(poolCatalog, recCtx, buildRecOptions());
      try {
        sessionStorage.setItem('oleum_recommendation_result', JSON.stringify(result));
      } catch (e3) {}
    }

    var headline = root.querySelector('[data-oleum-rec-headline]');
    var intro = root.querySelector('[data-oleum-rec-intro]');
    var primary = root.querySelector('[data-oleum-rec-primary]');
    var compWrap = root.querySelector('[data-oleum-rec-complementary-wrap]');
    var comp = root.querySelector('[data-oleum-rec-complementary]');
    var edu = root.querySelector('[data-oleum-rec-education]');
    var cta = root.querySelector('[data-oleum-rec-cta]');
    var quizBtn = root.querySelector('.oleum-rec-results__quiz');
    var empty = root.querySelector('[data-oleum-rec-empty]');

    if (!ctx) {
      if (empty) empty.hidden = false;
      if (quizBtn) quizBtn.hidden = false;
      return;
    }

    if (!result) {
      if (empty) empty.hidden = false;
      if (quizBtn) quizBtn.hidden = false;
      return;
    }

    if (headline) headline.textContent = result.headline || headline.textContent;
    if (intro) intro.textContent = result.intro || intro.textContent;
    renderEducation(result.education_blocks, edu);

    var primaryRanked = getResultProducts(result);
    var primaryShown = mountRankedProducts(primary, primaryRanked, poolIndex);

    if (compWrap) compWrap.hidden = true;

    if (primaryShown === 0) {
      if (empty) empty.hidden = false;
    } else if (empty) {
      empty.hidden = true;
    }

    if (cta && result.cta) {
      cta.textContent = result.cta.label || cta.textContent;
      cta.href = result.cta.url || cta.href;
    }

    if (quizBtn) quizBtn.hidden = false;

    initRecInfoInteractions(root);

    if (window.OleumAnalytics) {
      window.OleumAnalytics.trackRecommendationsView(ctx, result);
    }

    root.addEventListener('click', function (e) {
      var link = e.target.closest('[data-oleum-rec-product], .card__heading a, .product-card-wrapper a');
      if (!link) return;
      var card = link.closest('[data-product-id], [data-oleum-rec-product-item]');
      var pid =
        (card && card.getAttribute('data-product-id')) ||
        link.getAttribute('data-product-id');
      if (pid && window.OleumAnalytics) {
        window.OleumAnalytics.trackProductClick(ctx, pid);
      }
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
